import { useContext } from 'react'
import { Context as GeneralContext } from '@/context'
import { createUseStyles } from 'react-jss'
import DiagonalGallery from '@/components/DiagonalGallery'
import BtnLink from '@/components/BtnLink'
import YoutubeVideo from '@/components/YoutubeVideo'
import Carousel from '@/components/Carousel'

import style from './style'

const useStyles = createUseStyles(style)

export const BigText = ({ item }) => {
  const classes = useStyles(style)
  return item ? (
    <div
      // key={index}
      className={`${classes.wrapper} ${classes.introText}`}
      dangerouslySetInnerHTML={{ __html: item }}
    />
  ) : null
}

const Words = ({ item, strings }) => {
  const classes = useStyles(style)
  return (
    <div
      // key={index}
      className={classes.wrapper}
    >
      <div className={classes.grid}>
        <div className={classes.gridHeading}>
          <h2>{strings.words_title}</h2>
        </div>
        <div className={classes.gridContent}>
          <div className="text" dangerouslySetInnerHTML={{ __html: item.element_text }} />
          {item.element_link && (
            <BtnLink
              link={item.element_link}
              label={item.element_label}
            />
          )}
        </div>
      </div>
    </div>
  )
}

const VideoWrapper = ({ item }) => {
  const classes = useStyles(style)
  return (
    <div
     // key={i}
      className={classes.wrapper}
    >
      <YoutubeVideo
        className={classes.video}
        videoId={item.element_video}
      />
    </div>
  )
}

const DiagonalGalleryWrapper = ({ gallery }) => {
  const classes = useStyles(style)
  // const gallery = setGallery(item.element_gallery)

  return (
    <div
         // key={index}
      className={classes.wrapper}
    >
      <DiagonalGallery items={gallery} />
    </div>
  )
}

const SimpleGalleryWrapper = ({ gallery }) => {
  return (
    <Carousel
         // key={index}
      imagesList={gallery}
    />
  )
}

const PageBuilder = ({ page, stub, mediaQueryKey, strings }) => {
  const { getImageUrl } = useContext(GeneralContext)

  /*------------------------------
  Set Gallery
  ------------------------------*/
  const setGallery = (imagesList) => {
    if (imagesList.length > 0) {
      const gal = imagesList.split(',')
      const imgSize = mediaQueryKey > 2 ? 'full' : 'large'
      const galleryItems = gal.map((i) => {
        // Controllo se esiste l'immagine su media_post
        if (page.media_post[i]) {
          const { width, height, caption } = page.media_post[i]
          const src = getImageUrl(i, imgSize, stub, 'pages')
          const ratio = height / width

          return {
            src,
            width,
            height,
            caption,
            ratio,
          }
        }
        return null
      })

      return galleryItems[0] ? galleryItems : []
    }
    return []
  }

  return (
    <div className="pageBuilder">
      {
        page.page_element && page.page_element.map((element, i) => {
          if (element.layout_choice === 'diagonal_gallery') return <DiagonalGalleryWrapper key={i.toString()} gallery={setGallery(element.element_gallery)} />
          if (element.layout_choice === 'words') return <Words key={i.toString()} item={element} strings={strings} />
          if (element.layout_choice === 'video') return <VideoWrapper key={i.toString()} item={element} />
          if (element.layout_choice === 'simple_gallery') return <SimpleGalleryWrapper key={i.toString()} gallery={setGallery(element.element_gallery)} />
          if (element.layout_choice === 'article') return <BigText key={i.toString()} item={element.element_text} />
          return null
        })
      }
    </div>
  )
}

export default PageBuilder
